<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'hc.store' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeIds" [multiple]="true" (selectChange)="applyFilters()"></hx-store-select>
            </div>
            <div class="filter">
              <small>{{ 'filter.dates' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date" [maxMonthRange]="2" (selectChange)="applyFilters()"></hx-date-range-select>
            </div>
            <div class="filter">
              <small>{{ 'supplier-payment.interval' | transloco }}</small>
              <hx-enum-select [(ngModel)]="params.timeInterval" enumName="TimeInterval" [enumType]="TimeInterval" (selectChange)="applyFilters()"></hx-enum-select>
            </div>
            <div class="filter">
              <small>{{ 'storage.invoice.supplier' | transloco }}</small>
              <app-suppliers-search [(ngModel)]="params.supplierId" [storeIds]="params.storeIds" (selectChange)="applyFilters()"></app-suppliers-search>
            </div>
            <div class="filter">
              <small>&nbsp;</small>
              <hx-checkbox [(ngModel)]="params.paid" label="filter.paid" (valueChange)="applyFilters()"></hx-checkbox>
            </div>
            <div class="filter">
              <small>{{ 'filter.byDate' | transloco }}</small>
              <hx-checkbox [(ngModel)]="params.filterByCreateDate" label="filter.filterDate" [hideNo]="true" (valueChange)="applyFilters()"></hx-checkbox>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-12 text-left">
              <button type="button" (click)="resetFilter()" class="btn btn-outline-primary">
                <label class="label">{{ 'reset.list' | transloco }}</label>
              </button>
            </div>
          </div>
          <hr>
          <br/>
          <div class="report-title">
            {{ 'reports.supplier-payment' | transloco }} {{ 'report.per' | transloco }} {{ params.date?.from | date:'dd.MM.yyyy' }}
            - {{ params.date?.to | date:'dd.MM.yyyy' }}
          </div>
          <br/>
          <div class="block-table-scroll" *ngIf="list.length && !isLoading.list">
            <table>
              <thead>
              <tr class="fixed-head-oline">
                <th class="text-center min-width-10r fixed-head-one" [rowSpan]="3">{{ 'storage.invoice.supplier' | transloco }}</th>
                <th class="text-center min-width-10r fixed-head-two" [rowSpan]="3">{{ 'company.uin' | transloco }}</th>
                <th class="text-center min-width-10r fixed-head-three" [rowSpan]="3">{{ 'hc.store' | transloco }}</th>
                <th class="text-center min-width-10r fixed-head-three" [rowSpan]="3">{{ 'supplier-payment.bankAccountBalance' | transloco }}</th>
                <th *ngFor="let year of years" class="text-center" [colSpan]="getNumberOfDates(year)*2">{{ year }}</th>
                <th class="text-center" [rowSpan]="3">{{ 'report.total' | transloco }}</th>
              </tr>
              <tr class="fixed-head-tline">
                <th *ngFor="let d of dates" [colSpan]="2" class="text-center">
                  {{ d.startDate | date:'dd.MM' }} <span *ngIf="d.endDate && d.startDate !== d.endDate"> - {{ d.endDate | date:'dd.MM' }}</span>
                </th>
              </tr>
              <tr class="fixed-head-trline ">
                <th *ngFor="let item of [].constructor(dates.length*2); let i = index" class="text-center ">
                  <span *ngIf="0 === i % 2">
                    <span *ngIf="params.paid === undefined">{{ 'filter.paid.all' | transloco }}</span>
                    <span *ngIf="params.paid === true">{{ 'filter.paid.yes' | transloco }}</span>
                    <span *ngIf="params.paid === false">{{ 'filter.paid.no' | transloco }}</span>
                  </span>
                  <span *ngIf="0 !== i % 2">{{ 'supplier-payment.payment' | transloco }}</span>
                </th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let even = even;let i = index; let supplierPayment of list">
                <tr>
                  <td class="tbody-fixed-one">{{ supplierPayment.supplierName }}</td>
                  <td class="tbody-fixed-two">{{ supplierPayment.supplierUin }}</td>
                  <td class="tbody-fixed-three">{{ supplierPayment.storeName | uiLabel }}</td>
                  <td class="tbody-fixed-three" [contextMenu]="ctxBankAccount" [contextMenuValue]="{payment: supplierPayment, param: params}">
                    {{ supplierPayment.supplierBankAccountBalance | number }}
                  </td>
                  <ng-container *ngFor="let d of dates">
                    <td [contextMenu]="ctxMenu" [contextMenuValue]="{payment: supplierPayment, date: d.date}">
                      <a *ngIf="params.filterByCreateDate" class="decoration-none" [routerLink]="['/storage/invoices']" [queryParams]="{createDateFrom: d.startDate, createDateTo: d.endDate, storeIds: supplierPayment.storeIds, supplierId: supplierPayment.supplierId, paid: params.paid }">
                        {{ totalByDateAndSupplierMap.get(supplierPayment.supplierId + '-' + d.date + '-' + supplierPayment.storeId) | number }}
                      </a>
                      <a *ngIf="!params.filterByCreateDate" class="decoration-none" [routerLink]="['/storage/invoices']" [queryParams]="{dueDateFrom: d.startDate, dueDateTo: d.endDate, storeIds: supplierPayment.storeIds, supplierId: supplierPayment.supplierId, paid: params.paid }">
                        {{ totalByDateAndSupplierMap.get(supplierPayment.supplierId + '-' + d.date + '-' + supplierPayment.storeId) | number }}
                      </a>
                    </td>
                    <td>
                      <a class="decoration-none" [routerLink]="['/storage/payment-approvals']" [queryParams]="{dateFrom: d.startDate, dateTo: d.endDate, storeId: supplierPayment.storeId, paid: params.paid }">
                        {{ waitPaymentTotalByDateMap.get(supplierPayment.supplierId + '-' + d.date) ?? 0 | number }}
                      </a>
                    </td>
                  </ng-container>
                  <td class="bold" [contextMenu]="ctxMenu" [contextMenuValue]="{payment: supplierPayment}">
                    <a *ngIf="params.filterByCreateDate" class="decoration-none" [routerLink]="['/storage/invoices']" [queryParams]="{createDateFrom: params.date.from, createDateTo: params.date.to, storeIds: supplierPayment.storeIds?.join(','), supplierId: supplierPayment.supplierId, paid: params.paid }">
                      {{ totalBySupplierMap.get(supplierPayment.supplierId + '-' + supplierPayment.storeId) | number }}
                    </a>
                    <a *ngIf="!params.filterByCreateDate" class="decoration-none" [routerLink]="['/storage/invoices']" [queryParams]="{dueDateFrom: params.date.from, dueDateTo: params.date.to, storeIds: supplierPayment.storeIds?.join(','), supplierId: supplierPayment.supplierId, paid: params.paid }">
                      {{ totalBySupplierMap.get(supplierPayment.supplierId + '-' + supplierPayment.storeId)  | number}}
                    </a>
                  </td>
                </tr>
              </ng-container>
              </tbody>
              <tfoot class="table-footer-fixed">
              <tr>
                <th colSpan="4">{{ 'report.total' | transloco }}</th>
                <th *ngFor="let d of dates" [colSpan]="2">
                  <a *ngIf="params.filterByCreateDate" class="decoration-none" [routerLink]="['/storage/invoices']" [queryParams]="{createDateFrom: d.startDate, createDateTo: d.endDate, storeIds: params.storeIds.join(','), paid: params.paid }">
                    {{ this.totalByDateMap.get(d.date) ?? 0  | number }}
                  </a>
                  <a *ngIf="!params.filterByCreateDate" class="decoration-none" [routerLink]="['/storage/invoices']" [queryParams]="{dueDateFrom: d.startDate, dueDateTo: d.endDate, storeIds: params.storeIds.join(','), paid: params.paid }">
                    {{ this.totalByDateMap.get(d.date) ?? 0  | number }}
                  </a>
                </th>
                <th>
                  <a *ngIf="params.filterByCreateDate" class="decoration-none" [routerLink]="['/storage/invoices']" [queryParams]="{createDateFrom: params.date.from, createDateTo: params.date.to, storeIds: params.storeIds.join(','), paid: params.paid }">
                    {{ total | number }}
                  </a>
                  <a *ngIf="!params.filterByCreateDate" class="decoration-none" [routerLink]="['/storage/invoices']" [queryParams]="{dueDateFrom: params.date.from, dueDateTo: params.date.to, storeIds: params.storeIds.join(','), paid: params.paid }">
                    {{ total | number }}
                  </a>
                </th>
              </tr>
              </tfoot>
            </table>
          </div>
          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>
          <br/>
          <br/>

          <div class="m--align-center" *ngIf="list.length && !isLoading.list && pagination.allItemCount > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                            [(page)]="params.page" [pageSize]="params.limit"
                            (pageChange)="pageChanged($event)" class="d-flex justify-content-center mt-4">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<context-menu #ctxMenu>
  <ng-template contextMenuItem (execute)="createPaymentApproval($event.value)">{{ 'supplier-payment.paymentOrder' | transloco }}</ng-template>
</context-menu>

<context-menu #ctxBankAccount>
  <ng-template contextMenuItem let-item (execute)="showCredit($event.value)"><span class="bold">{{ 'supplier-payment.credit' | transloco }}:</span> {{ item.payment?.credit | number }}</ng-template>
  <ng-template contextMenuItem let-item (execute)="showDebit($event.value)"><span class="bold">{{ 'supplier-payment.debit' | transloco }}:</span> {{ item.payment?.debit | number }}</ng-template>
</context-menu>
